// extracted by mini-css-extract-plugin
export default {"input":"HVCheckbox_module-K4ZWX45T_input__FKdiz","icon":"HVCheckbox_module-K4ZWX45T_icon__puzxT"};